import { ItemSource } from './source-section.model';
import { PaymentMethod } from './payment-method.model';
import { Address } from "./address.model";
import { ProductVariant } from "./product.model";


export interface Payment {
  id: string;
  payment_method: string; 
  paid_at: string | null; 
  third_party_token: string | null;
  additional_data: any | null; 
  status: string;
  billing_address_id: string | null;
  reference_order_id: string | null;
}

// The main Checkout model
export interface Checkout {
  id: string;
  coupon_code: string | null;
  sub_total: number;
  handling_fee: number;
  checkout_count: number |null;
  shipping_fee: number;
  discount: number;
  grand_total: number;
  status: string;
  reference_order_id: string | null;
  payment: Payment;
  address: Address;
  checkout_items: CheckoutItem[];
}
export interface CheckoutItem extends ItemSource {
  id: string;
  product_variant_id: string;
  quantity: number;
  unit_price: number;
  product_variant: ProductVariant;
}